goog.provide('el8.plrdata.base');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.report');
goog.require('el8.util.base');


/**
 * This file caches data belonging to charts in other practices
 * that we are authorized to see. It is primarily used to store
 * PLR chart feed results that haven't been imported into our practice,
 * so we can render them in the feed/dialogs without mixing them
 * up with our own reports, visits, etc.
 */

/* This is a naive cache of server JSON that we use for PLR models
 * We'll be able to fetch the data by ID, but otherwise will not
 * break out the properties of the object.
 *
 * Sometimes, we need aspects of a custom soy map to render
 * a PLR object; in those cases, we can grab the raw JSON and throw
 * it into the model before use.
 */
el8.plrdata.jsonCache = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty('patientId');
    _class.addIntProperty('sourcePracticeId');
    _class.addDateTime('chartFeedDate');

    _class.addBoolean('plr', false, true); // conveniently identify PLR data
    _class.addProperty('json'); // we're just going to throw the whole JSON in here
    _class.makeSignable(); // add functions for getting the signUser data

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);

        this.setJson(spec);
    };

    // if we're directly accessing the JSON, we'll often want
    // it camel-cased, as it would come out of a client-side model
    _class.prototype.getCamelJson = function() {
        return el8.util.keysFromUnderscoreToCamel(this.getJson());
    };

    _class.prototype.asSoyMap = function() {
        // the map is all in the `json` field, but we may need to convert
        // some IDs to names, etc.
        var mapped = this.getCamelJson();

        if (mapped.signUserId || mapped.signUser) {
            mapped['signUserName'] = this.getSignUserName();
            mapped['signUserType'] = this.getSignUserType();
            if (mapped['signUserType'].cmp('Physician')) {
                mapped['prescribingPhysicianName'] = mapped['signUserType'];
            }
        }
        if (mapped.signUserBehalfId || mapped.signUserBehalf) {
            mapped['signUserBehalfName'] = this.getSignUserBehalfName();
            mapped['signUserBehalfType'] = this.getSignUserBehalfType();
            mapped['behalfUserName'] = mapped['signUserBehalfName'];
        }

        // FUTURE: For LabOrders, we now populate testnames via .populate() which isn't
        // run here since the map returned from this function is directly fed into
        // templateFn's without hydrating the object. Use the same approach as above,
        // but should have a better long-term solution.
        if (mapped.tests && !_.isEmpty(mapped.tests) && _.isEmpty(mapped.testNames)) {
            mapped.testNames = _.map(mapped.tests, function(test) {
                return test.name ? test.name : '';
            });
        }
        return mapped;
    };

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); }
    });

})();


/* These two functions exist in case we add other entity sets in the future
 */
el8.plrdata.getById = function(id) {
    return el8.plrdata.jsonCache.getById(id, true);
};

// FeedId comes in the form of feedItem_Letter_67268247770
// Used only for PLR shared chart items in the pt chart feed
el8.plrdata.getByFeedId = function(fid) {
    var parts = fid.split('_');
    if (parts.length === 3) { return el8.plrdata.jsonCache.getById(parts[2], true); }
    else { return null; }
};

el8.plrdata.getModelClass = function(id) {
    return el8.plrdata.jsonCache;
};
